type StoreCatalogCoinSortable = {
  id: number
  /** Preço vindo da categoria da variação. */
  price?: number | null
  /** @deprecated Valor legado do item; some no fim do deploy em duas fases. */
  coin?: number | null
}

/** O preço do resgate: da categoria, com o legado como ponte. */
const priceOf = (item: StoreCatalogCoinSortable): number =>
  Number(item.price ?? item.coin ?? 0)

export const compareStoreCatalogItemsByCoin = <T extends StoreCatalogCoinSortable>(
  a: T,
  b: T
): number => {
  const priceDiff = priceOf(a) - priceOf(b)

  if (priceDiff !== 0) {
    return priceDiff
  }

  return a.id - b.id
}

export const sortStoreCatalogItemsByCoin = <T extends StoreCatalogCoinSortable>(
  items: T[]
): T[] => [...items].sort(compareStoreCatalogItemsByCoin)
